import clsx from 'clsx'

export type InputClassOptions = {
  prefix?: string
  size?: string
  solid?: boolean
  white?: boolean
  flush?: boolean
  shadow?: boolean
  className?: string
  [key: string]: unknown
}

const CONTROL_BORDER =
  'border-2 border-contour focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20'

const BASE_INPUT = clsx(
  'w-full rounded-[0.625rem] bg-white px-3 py-2.5 text-sm text-gray-900',
  'placeholder:text-gray-500 transition-colors',
  CONTROL_BORDER
)

const BASE_SELECT = clsx(
  'w-full rounded-[0.625rem] bg-white px-3 py-2.5 text-sm text-gray-900 appearance-none',
  'transition-colors',
  CONTROL_BORDER
)

const BASE_INPUT_GROUP = clsx(
  'flex items-stretch rounded-[0.625rem] overflow-hidden bg-white',
  'focus-within:border-brand focus-within:ring-2 focus-within:ring-brand/20 transition-colors',
  'border-2 border-contour'
)

export const getInputClasses = (
  {
    prefix = 'text-input',
    size,
    solid,
    white,
    flush,
    shadow,
    className = '',
    ...rest
  }: InputClassOptions = {},
  isInvalid = false
): string => {
  if (prefix === 'input-group') {
    return clsx(
      BASE_INPUT_GROUP,
      solid && 'bg-gray-100 border-transparent',
      size === 'sm' && 'text-xs',
      shadow && 'shadow-sm',
      isInvalid && 'border-danger focus-within:ring-danger',
      className
    )
  }

  if (prefix === 'form-check') {
    return clsx(
      'flex items-start gap-2 pt-3',
      className
    )
  }

  const base = prefix === 'form-select' ? BASE_SELECT : BASE_INPUT

  return clsx(
    base,
    solid && 'bg-gray-100 border-transparent focus:bg-white',
    white && 'bg-white',
    flush && 'border-0 rounded-none px-0',
    size === 'sm' && 'h-9 text-xs py-1.5 px-2.5',
    shadow && 'shadow-sm',
    isInvalid && 'border-danger ring-2 ring-danger',
    className
  )
}

export default getInputClasses
